import Joyride from 'react-joyride';
import { useTranslation } from "react-i18next";
import { useTourStore } from '../stores/zustand';
import React, { useEffect, useState } from 'react';

const OverallTour = () => {
    const { t } = useTranslation();
    const { isTourOpen, nextStep, closeTour } = useTourStore();
    const [runTour, setRunTour] = useState(false);
    const introductionText = t('schedulerIntroduction', { returnObjects: true });

    var steps = [
        {
            target: 'body',
            content: introductionText.map((line, index) => (
                <p key={index}>{line}</p>
            )),
            placement: 'center',
        },
        {
            target: '.clickableCursor', // Selector for the FullCalendar element
            content: t('calendarSteps1'),
            placement: 'auto',
            disableBeacon: true,
        },
        {
            target: '.add-entry-button', // Selector for the "Add Entry" button
            content: t('calendarSteps2'),
            placement: 'right',
            disableBeacon: true,
        },
        {
            target: '.addToCalendarButton', // Selector for the "Add to Calendar" button
            content: t('calendarSteps3'),
            placement: 'top',
            disableBeacon: true,
        },
        {
            target: '.nav-button-feedback',
            content: t('clickHereFeedback'),
            placement: 'top',
            disableBeacon: true,
            spotlightClicks: true,
        },
        {
            target: '.feedbackForm',
            content: t('feedbackSteps1'),
            placement: 'left',
            disableBeacon: true,
        },
        {
            target: '.nav-button-library',
            content: t('clickHereLibrary'),
            placement: 'top',
            disableBeacon: true,
            spotlightClicks: true,
        },
        {
            target: '.preferenceSelector',
            content: t('librarySteps1'),
            placement: 'auto',
        },
        {
            target: '.libraryGrid',
            content: t('librarySteps2'),
            placement: 'bottom',
        },
        {
            target: '.nav-button-settings',
            content: t('clickHereSettings'),
            placement: 'top',
            disableBeacon: true,
            spotlightClicks: true,
        },
        {
            target: '.settingsDivider',
            content: t('settingsSteps1'),
            placement: 'top-end',
        },
        {
            target: '.movementSwitch',
            content: t('settingsSteps2'),
            placement: 'auto',
        },
        {
            target: '.movementSnoozeSwitch',
            content: t('settingsSteps3'),
            placement: 'auto',
        },
        {
            target: '.movementCard',
            content: t('settingsSteps4'),
            placement: 'auto',
        },
        {
            target: '.exerciseToggleButton',
            content: t('clickHere'),
            placement: 'auto',
            disableBeacon: true,
            spotlightClicks: true,
        },
        {
            target: '.exerciseSwitch',
            content: t('settingsSteps5'),
            placement: 'auto',
        },
        {
            target: '.exerciseSnoozeSwitch',
            content: t('settingsSteps6'),
            placement: 'auto',
        },
        {
            target: '.exerciseCard',
            content: t('settingsSteps7'),
            placement: 'auto',
        },
        {
            target: '.nav-button-schedule',
            content: t('clickHere'),
            placement: 'top',
            disableBeacon: true,
            spotlightClicks: true,
        },
        {
            target: '.video-button',
            content: t('startTutorialVideo'),
            placement: 'top',
            disableBeacon: true,
            spotlightClicks: true,
        },
        {
            target: 'body',
            content: t('tourEnded'),
            placement: 'center',
            hideFooter: true,
        },
    ];

    useEffect(() => {
        if (isTourOpen) {
            const timer = setTimeout(() => {
                setRunTour(true);
            }, 100); // Delay of 100 mssecond

            return () => clearTimeout(timer); // Cleanup timer on component unmount
        } else {
            setRunTour(false); // Reset runTour when tour is closed
        }
    }, [isTourOpen]);

    const handleJoyrideCallback = (data) => {
        const { action, lifecycle, step } = data;

        if (action === 'close' || data.status === 'finished') {
            closeTour();
        }

        // Handle click interaction for .nav-button-feedback
        if (lifecycle === 'ready' && step.target === '.nav-button-feedback') {
            const feedbackButtonElement = document.querySelector('.nav-button-feedback');
            if (feedbackButtonElement) {
                feedbackButtonElement.addEventListener('click', () => {
                    setTimeout(() => {
                        nextStep(); // Proceed to the next step after 500ms delay
                    }, 500);
                }, { once: true });
            }
        }
    };

    return (
        <Joyride
            steps={steps}
            //stepIndex={stepIndex} //ToDo mess around with adding this back so nextStep works. 
            continuous={true}
            showSkipButton={false}
            run={runTour}
            styles={{
                options: {
                    arrowColor: '#1a76d2',
                    primaryColor: '#1a76d2',
                    width: 500,
                    zIndex: 1000,
                }
            }}
            locale={{
                back: t('back'),
                close: t('close'),
                last: t('last'),
                next: t('next'),
                skip: t('skip'),
            }}
            callback={handleJoyrideCallback}
        />
    );
};
export default OverallTour;